import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import { fetchMiscs } from "../../store/slices/miscsSlice";
import { fetchSEOPages } from "../../store/slices/seoSlice";
// import Community from "./components/Community";
import AboutUsHeader from "./components/Header";
// import Milestones from "./components/Milestones";
// import Mission from "./components/Mission";
import OurStory from "./components/OurStory";
// import MobileMission from "./components/MobileMission";
// import MobileCommunity from "./components/MobileComunity";
import Loader from "../../components/base-components/Loader";
import ErrorMessage from "../../components/base-components/Error";

const AboutUs: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const { miscs, status, error } = useSelector(
    (state: RootState) => state.miscs
  );

  const {
    seoPages,
    status: seoStatus,
    error: seoError,
  } = useSelector((state: RootState) => state.seoPages);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchMiscs());
    }

    if (seoStatus === "idle") {
      dispatch(fetchSEOPages());
    }
  }, [dispatch, status, seoStatus]);

  if (status === "loading" || seoStatus === "loading") {
    return <Loader />;
  }

  if (status === "failed") {
    return <ErrorMessage message={error} />;
  }

  if (seoStatus === "failed") {
    return <ErrorMessage message={seoError} />;
  }

  const getMiscValue = (key: string) => {
    return (
      miscs.find((misc) => misc.attributes.title === key)?.attributes.value ||
      ""
    );
  };

  const getSEOData = () => {
    return seoPages.find(
      (page) => `/${page.attributes.url}` === location.pathname
    )?.attributes;
  };

  const seo = getSEOData();

  return (
    <>
      <Helmet>
        <title>{seo?.seo_title}</title>
        {seo?.seo_description && (
          <meta name="description" content={seo.seo_description} />
        )}

        <link rel="canonical" href={window.location.href} />
        <meta
          property="og:image"
          content="https://www.dancap-group.co.uk/images/dancap-logo-dark.jpg"
        />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        <meta property="og:title" content={seo?.seo_title} />
        <meta property="og:description" content={seo?.seo_description} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:image"
          content="https://www.dancap-group.co.uk/images/dancap-logo-dark.jpg"
        />
      </Helmet>
      <AboutUsHeader description={getMiscValue("aboutus_page_description")} />
      <OurStory storyText={getMiscValue("aboutus_our_story")} />
      {/* <Milestones /> */}
      {/* <Mission missionText={getMiscValue("aboutus_mission")} />
      <MobileMission missionText={getMiscValue("aboutus_mission")} />
      <Community communityText={getMiscValue("aboutus_community")} />
      <MobileCommunity communityText={getMiscValue("aboutus_community")} /> */}
    </>
  );
};

export default AboutUs;
